import React from 'react';
import dynamic from 'next/dynamic';
import { NextPage } from 'next';
import { store } from '../../../core/redux/store';
import i18n from 'i18next';
import { PERSIAN } from '../../../core/services/CONSTANTS';
import { Provider } from 'react-redux';
import { CacheProvider } from '@emotion/react';
import { StyleSheetManager } from 'styled-components';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

const Note = dynamic(() => import('../../../page/tools/notebook/index'), { ssr: false });

const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin]
});

const cache = createCache({
  key: 'mui'
});

const NoteNoSSR: NextPage = () => {
  return (
    <Provider store={store}>
      <CacheProvider value={i18n.language === PERSIAN ? cacheRtl : cache}>
        <StyleSheetManager>
          <Note />
        </StyleSheetManager>
      </CacheProvider>
    </Provider>
  );
};

export default NoteNoSSR;
